import { render, staticRenderFns } from "./supplierSingkek.vue?vue&type=template&id=ed75324a&scoped=true&"
import script from "./supplierSingkek.vue?vue&type=script&lang=js&"
export * from "./supplierSingkek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed75324a",
  null
  
)

component.options.__file = "supplierSingkek.vue"
export default component.exports